module.exports = __webpack_public_path__ + "media/img/Landing_Page/yt-icon-201d1e827b6144c5e76f62bf2f1591b5.png";